import { useTranslation } from 'react-i18next';

import { PageSeo } from '../components/PageSeo';
import { SubpageLayout } from '../components/SubpageLayout';
import { SENIOR_FIVE_PRESIDENTS_VIDEO_URL } from '../data/seniorFivePresidentsContent';

/**
 * En kıdemli beş başkan — URL: /senior-five-presidents
 */
export function SeniorFivePresidentsPage() {
    const { t } = useTranslation();

    return (
        <>
            <PageSeo
                title={`${t('seniorFivePresidents.title')} — ${t('header.rotaryAlt')}`}
                description={t('seo.seniorFive')}
            />
            <SubpageLayout
                title={t('seniorFivePresidents.title')}
                subtitle={t('seniorFivePresidents.subtitle')}
                contentClassName="subpage-video-page"
            >
            <div className="subpage-video-wrap">
                <video
                    className="subpage-video"
                    controls
                    playsInline
                    preload="metadata"
                    aria-label={t('seniorFivePresidents.videoAriaLabel')}
                >
                    <source src={SENIOR_FIVE_PRESIDENTS_VIDEO_URL} type="video/mp4" />
                    {t('seniorFivePresidents.videoNotSupported')}
                </video>
            </div>
        </SubpageLayout>
        </>
    );
}
